(() => {
  const parseJSON = (node) => {
    try { return JSON.parse(node?.textContent || '[]'); }
    catch (_) { return []; }
  };

  const imageURL = (variant) => {
    if (!variant) return '';
    if (variant.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    if (variant.featured_image?.src) return variant.featured_image.src;
    return typeof variant.featured_image === 'string' ? variant.featured_image : '';
  };

  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const colorCode = (value) => (value || '').split('-')[0].trim().toUpperCase();
  const mediaFilename = (url) => decodeURIComponent(String(url || '').split('/').pop()?.split('?')[0] || '').toUpperCase();
  const inferredImageURL = (media, color) => {
    const code = colorCode(color);
    if (!code) return '';
    const pattern = new RegExp(`-${escapeRegExp(code)}(?:_|\\.|-)`);
    return media.find((item) => pattern.test(mediaFilename(item.url)) || pattern.test(String(item.alt || '').toUpperCase()))?.url || '';
  };

  const initColorSelector = (root) => {
    const variants = parseJSON(root.querySelector('[data-home-variants]'));
    const media = parseJSON(root.querySelector('[data-home-media]'));
    const mainImage = root.querySelector('#TfpHomeLure');
    const buttons = [...root.querySelectorAll('[data-home-color]')];

    buttons.forEach((button, index) => {
      const variant = variants.find((item) => item.options?.[0] === button.dataset.homeColor && imageURL(item));
      const url = imageURL(variant) || inferredImageURL(media, button.dataset.homeColor) || media[index]?.url || '';
      const swatch = button.querySelector('[data-home-swatch]');

      if (url && swatch) {
        swatch.src = url;
        swatch.hidden = false;
        button.classList.add('has-image');
      }

      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.toggle('selected', item === button));
        if (!mainImage || !url) return;
        mainImage.style.opacity = '.15';
        const preload = new Image();
        preload.onload = () => {
          mainImage.src = url;
          mainImage.srcset = '';
          mainImage.alt = button.dataset.homeColor;
          mainImage.style.opacity = '1';
        };
        preload.onerror = () => { mainImage.style.opacity = '1'; };
        preload.src = url;
      });
    });
  };

  const initHero = (root) => {
    const hero = root.querySelector('[data-home-hero]');
    if (hero?.dataset.mode !== 'video') return;
    const video = hero.querySelector('video');
    video?.play().catch(() => { hero.dataset.mode = 'image'; });
  };

  const init = () => {
    const root = document.querySelector('.tfp-home');
    if (!root) return;
    initColorSelector(root);
    initHero(root);
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
